
























































































































































































































































































import { AvisDeVirementApi } from "../api/AvisDeVirementApi";
import ConfirmSuppression from "../core/Modals/ConfirmSuppression";
import ExportButton from "../core/UI/ExportButton.vue";
import Pagination from "../core/UI/Pagination.vue";
import PerPage from "../core/UI/PerPage.vue";
import AvisDeVirementListFilters from "./AvisDeVirementListPartials/AvisDeVirementListFilters.vue";
import AvisDeVirementLignes from "./AvisDeVirementListPartials/AvisDeVirementLignes.vue";
import AvisDeVirementLigneModal from "./AvisDeVirementListPartials/AvisDeVirementLigneModal.vue";
import AutoRefresh from "../core/Table/AutoRefresh.vue";
import AvisDeVirementModal from "./AvisDeVirementModal.vue";
import ReleveBancaireImportModal from "./AvisDeVirementListPartials/ReleveBancaireImportModal.vue";
import { Routes } from "../utils/Routes";
import { AvisDeVirement } from "../models/AvisDeVirement";

export default {
    name: "AvisDeVirementList",
    components: {
        ExportButton,
        Pagination,
        PerPage,
        AvisDeVirementListFilters,
        AvisDeVirementLignes,
        AvisDeVirementLigneModal,
        AutoRefresh,
        AvisDeVirementModal,
        ReleveBancaireImportModal,
    },
    data() {
        return {
            avisDeVirements: [],
            montantTotal: 0,
            AvisDeVirementApi: new AvisDeVirementApi(),
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            loading: false,
            filters: {},
            sort: "",
            expanded: {},
            editingLigne: null,
            rowClickTimer: null,
            showImportModal: false,
            avisDeVirementModal: {
                avisDeVirementId: null,
                isNew: false,
                forceEditing: false,
            },
        };
    },
    created() {
        this.loadPage(this.currentPage);
    },
    methods: {
        loadPage(page, hideLoading = false) {
            let self = this;
            let params = {
                limit: self.itemsPerPage,
                page: page,
                include: "files,lignes",
                sort: this.sort,
            };

            params = _.assign(params, self.filters);
            self.loading = !hideLoading;

            return self.AvisDeVirementApi.getAll(params)
                .then(function (response) {
                    let { data, metadata, paginator } = response;

                    self.avisDeVirements = data;
                    self.totalPages = paginator.total_pages;
                    self.currentPage = paginator.current_page;
                    self.montantTotal = metadata.montant_total;

                    return self.avisDeVirements;
                })
                .catch(function (error) {
                    self.avisDeVirements = [];
                })
                .finally(function () {
                    self.loading = false;
                });
        },
        getAvisDeVirements() {
            return this.loadPage(this.currentPage);
        },
        refreshAvisDeVirements() {
            if (!this.loading) {
                this.loadPage(this.currentPage, true);
            }
        },
        updateFilters(filters): void {
            this.filters = filters;
            this.loadPage(1);
        },
        updateSort(sort): void {
            this.sort = sort;
            this.loadPage(1);
        },
        getExportParams() {
            return _.assign({ sort: this.sort }, this.filters);
        },
        editAvis(avis) {
            this.avisDeVirementModal.isNew = false;
            this.avisDeVirementModal.forceEditing = true;
            this.avisDeVirementModal.avisDeVirementId = avis.id;
        },
        onAvisDeVirementModalClose() {
            this.avisDeVirementModal.avisDeVirementId = null;
            this.avisDeVirementModal.forceEditing = false;
            this.avisDeVirementModal.isNew = false;
            this.refreshAvisDeVirements();
        },
        deleteAvis(avis) {
            let self = this;
            ConfirmSuppression.demanderRaison(
                "Voulez vous supprimer cet avis de virement&nbsp;?"
            ).then(function (raison) {
                if (raison === null) {
                    return;
                }
                self.AvisDeVirementApi.delete(avis.id, raison)
                    .then(function () {
                        self.getAvisDeVirements();
                        swal(
                            "L'avis de virement a bien été supprimé !",
                            "",
                            "success"
                        );
                    })
                    .catch(function (error) {
                        let data =
                            (error.response && error.response.data) || {};
                        swal(
                            "Suppression impossible",
                            data.message ||
                                (data.error && data.error.message) ||
                                "",
                            "error"
                        );
                    });
            });
        },
        openImportModal() {
            this.showImportModal = true;
        },
        closeImportModal() {
            this.showImportModal = false;
        },
        onReleveImported() {
            // La modale reste ouverte sur son rapport : la liste est
            // rafraîchie en arrière-plan.
            this.refreshAvisDeVirements();
        },
        setRapprochement(avis, mode) {
            let self = this;

            return self.AvisDeVirementApi.setRapprochement(avis.id, mode).then(
                function () {
                    self.refreshAvisDeVirements();
                }
            );
        },
        marquerEffectue(avis) {
            this.setRapprochement(avis, AvisDeVirement.MODE["manuel"]);
        },
        annulerRapprochement(avis) {
            let self = this;

            swal({
                title: "Annuler le rapprochement de cet avis ?",
                text:
                    "Les opérations bancaires liées seront libérées et l'avis " +
                    "ne sera plus rapproché automatiquement.",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success",
                confirmButtonText: "Oui",
                cancelButtonClass: "btn btn-default",
                cancelButtonText: "Non",
                buttonsStyling: false,
            }).then(function () {
                self.setRapprochement(avis, AvisDeVirement.MODE["exclu"]);
            });
        },
        reactiverRapprochement(avis) {
            this.setRapprochement(avis, AvisDeVirement.MODE["auto"]);
        },
        toggleLignes(avis) {
            // $set : nouvelle clé d'objet, sinon Vue 2 ne réagit pas.
            this.$set(this.expanded, avis.id, !this.expanded[avis.id]);
        },
        roundAmount(amount) {
            return _.round(amount || 0, 2).toFixed(2);
        },
        onRowClick(avis, event) {
            // Les liens et boutons de la ligne gardent leur propre action.
            if (event.target.closest("a, button, input")) {
                return;
            }
            if (!avis.lignes_count) {
                return;
            }
            // Le simple clic attend un éventuel double clic (édition) avant
            // de plier/déplier.
            clearTimeout(this.rowClickTimer);
            this.rowClickTimer = setTimeout(() => {
                this.toggleLignes(avis);
            }, 250);
        },
        onRowDblClick(avis, event) {
            if (event.target.closest("a, button, input")) {
                return;
            }
            clearTimeout(this.rowClickTimer);
            this.editAvis(avis);
        },
        editLigne(ligne) {
            this.editingLigne = ligne;
        },
        onLigneSaved() {
            // Recharge la page courante pour rafraîchir lignes et totaux,
            // sans toucher à l'état de dépliage (indexé par id d'avis).
            this.refreshAvisDeVirements();
        },
        // UI
        rapprochementLabelClass(avis: AvisDeVirement): string {
            if (avis.is_effectue) {
                return "label-success";
            }
            if (avis.is_partiel) {
                return "label-warning";
            }
            return "label-default";
        },
        canMarquerEffectue(avis: AvisDeVirement): boolean {
            return !avis.is_effectue;
        },
        addContactUrl(avis: AvisDeVirement): string {
            if (avis.client_name) {
                return Routes.new_contact + "?nom=" + avis.client_name;
            }
        },
        showMailInfo() {
            swal({
                title: "Import de documents",
                text:
                    "Les avis de virement doivent être transférés par mail à l'adresse <a href='mailto:" +
                    window.documentMail +
                    "'>" +
                    window.documentMail +
                    "</a>" +
                    "<br/>" +
                    "Format pdf uniquement, un avis par fichier, plusieurs avis dans le même mail possible.",
                type: "info",
                showCancelButton: false,
                confirmButtonClass: "btn btn-success",
                confirmButtonText: "OK",
            });
        },
    },
    watch: {
        itemsPerPage: function () {
            this.loadPage(1);
        },
        filters: {
            deep: true,
            handler: function () {
                this.loadPage(1);
            },
        },
        sort: function () {
            this.loadPage(1);
        },
    },
};
